export default __webpack_public_path__ + "static/media/Highlord's War Glaive.45c3d465.jpg";